var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from '../elements/icon';
import { SliceLayoutBoundary } from '../entities/slice-layout';
import { classNames } from '@shapeable/utils';
import { useSite } from '../hooks/use-site';
import { SiteHeaderLogo } from './site-header-logo';
import { useSiteSidebar } from '../hooks/use-site-sidebar';
import { SiteMenuSidebar } from '../entities/site-menu-sidebar';
import { useDimensions } from '../hooks/use-dimensions';
import { useLinearNavigation } from '../hooks/use-linear-navigation';
import { LinearNavigation } from '../elements/linear-navigation';
import { CrossIcon } from '@shapeable/icons';
var cls = classNames('menu-mobile');
export var SiteMenuRevealDefaultProps = {
  variant: 'default',
  isInverted: true,
  hasNavigationMenu: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    left: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n    z-index: 400;\n    width: 100%;\n    padding-bottom: ", ";\n    background: ", ";\n\n    ", "\n  "], ["\n    position: fixed;\n    left: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n    z-index: 400;\n    width: 100%;\n    padding-bottom: ", ";\n    background: ", ";\n\n    ", "\n  "])), theme.UNIT(1), theme.COLOR('canvas'), function (_a) {
    var _height = _a._height;
    return _height && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), _height);
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasSidebar = _a.hasSidebar,
      sidebarWidth = _a.sidebarWidth;
    return hasSidebar && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: auto;\n      width: calc(100% - ", "px);\n    "], ["\n      height: auto;\n      width: calc(100% - ", "px);\n    "])), sidebarWidth);
  }),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    ", "\n  "])), function (_a) {
    var heightMobile = _a.heightMobile;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightMobile);
  }),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightTablet = _a.heightTablet,
      variant = _a.variant;
    return variant === 'default' && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightTablet);
  }),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightDesktop = _a.heightDesktop,
      variant = _a.variant;
    return variant === 'default' && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightDesktop);
  })
});
var CloseButtonStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n\n  "], ["\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n\n  "])), function (_a) {
    var showSidebar = _a.showSidebar;
    return showSidebar && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: block;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n  "], ["\n    display: block;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return variant === 'default' && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), theme.UNIT(3));
  }),
  last: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    @media (max-width: 360px) {\n      width: 24px;\n      height: 24px;\n\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  "], ["\n    @media (max-width: 360px) {\n      width: 24px;\n      height: 24px;\n\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  "])))
});
var SidebarStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n  "], ["\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n  "]))),
  tablet: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    width: 100%;\n\n    ", "\n  "], ["\n    width: 100%;\n\n    ", "\n  "])), function (_a) {
    var sidebarWidth = _a.sidebarWidth;
    return sidebarWidth && css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      width: calc(100% - ", "px);\n    "], ["\n      width: calc(100% - ", "px);\n    "])), sidebarWidth);
  }),
  tablet: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
// const LinearNavigationContainerStyles = breakpoints({
//   base: css`
//     display: none;
//   `,
//   tablet: css`
//     display: flex;
//     margin-top: -${theme.UNIT(0.5)};
//   `
// });
var LinearNavigationStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding: ", " 0;\n\n    .shp--slim-select {\n      height: 40px;\n    }\n   \n    .shp--slim-select__control {\n      background-color: rgba(255, 255, 255, 0.1);\n      color: #FFF;\n      font-size: 1em;\n      padding: ", " ", ";\n      border-color: transparent;\n    }\n\n    .shp--slim-select__control--is-focused {\n      border-color: ", ";\n    }\n\n    .shp--slim-select__menu {\n      background-color: #323232;\n      color: ", ";\n      font-size: 1em;\n    }\n\n    .shp--slim-select__input {\n      color: ", ";\n      font-size: 1em;\n    }\n\n    .shp--slim-select__menu-list {\n      padding-bottom: 0;\n    }\n\n    .shp--slim-select__option {\n      border-color: #666;\n      color: ", ";\n      font-size: 1em;\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:last-child {\n        border: none;\n      }\n    }\n\n    .shp--slim-select__indicator {\n      .shp--triangle {\n        border-top: 6px solid ", ";\n      }\n    }\n    \n    .shp--slim-select__option--is-focused {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    ", " {\n      padding-left: 0;\n      border-right: none;\n    }\n\n    ", " {\n      padding-right: 0;\n    }\n  "], ["\n    flex-grow: 1;\n    padding: ", " 0;\n\n    .shp--slim-select {\n      height: 40px;\n    }\n   \n    .shp--slim-select__control {\n      background-color: rgba(255, 255, 255, 0.1);\n      color: #FFF;\n      font-size: 1em;\n      padding: ", " ", ";\n      border-color: transparent;\n    }\n\n    .shp--slim-select__control--is-focused {\n      border-color: ", ";\n    }\n\n    .shp--slim-select__menu {\n      background-color: #323232;\n      color: ", ";\n      font-size: 1em;\n    }\n\n    .shp--slim-select__input {\n      color: ", ";\n      font-size: 1em;\n    }\n\n    .shp--slim-select__menu-list {\n      padding-bottom: 0;\n    }\n\n    .shp--slim-select__option {\n      border-color: #666;\n      color: ", ";\n      font-size: 1em;\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:last-child {\n        border: none;\n      }\n    }\n\n    .shp--slim-select__indicator {\n      .shp--triangle {\n        border-top: 6px solid ", ";\n      }\n    }\n    \n    .shp--slim-select__option--is-focused {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    ", " {\n      padding-left: 0;\n      border-right: none;\n    }\n\n    ", " {\n      padding-right: 0;\n    }\n  "])), theme.UNIT(3), theme.UNIT(1), theme.UNIT(2.2), theme.COLOR('link-hover'), theme.COLOR('light'), theme.COLOR('light'), theme.COLOR('light'), theme.COLOR('link-hover'), theme.COLOR('light'), theme.COLOR('light'), theme.COLOR('dark'), LinearNavigation.cls.child('prev-button'), LinearNavigation.cls.child('next-button')),
  tablet: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    .shp--page-navigation__select {\n      width: 100%;\n    }\n    \n  "], ["\n    .shp--page-navigation__select {\n      width: 100%;\n    }\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Logo: styled(SiteHeaderLogo)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  CloseButton: styled(Icon)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles),
  // LinearNavigationContainer: styled.div`${LinearNavigationContainerStyles}`,
  LinearNavigation: styled(LinearNavigation)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LinearNavigationStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Sidebar: styled(SiteMenuSidebar)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), SidebarStyles)
};
/* @ts-ignore */
export var SiteMenuReveal = React.forwardRef(function (props, ref) {
  var className = props.className,
    isInverted = props.isInverted,
    onCloseClick = props.onCloseClick,
    variant = props.variant,
    hasNavigationMenu = props.hasNavigationMenu,
    children = props.children;
  var info = useLinearNavigation();
  var isLinearNav = info.isLinearNav;
  var _a = useSite(),
    headerHeightMobile = _a.headerHeightMobile,
    headerHeightTablet = _a.headerHeightTablet,
    headerHeightDesktop = _a.headerHeightDesktop;
  var _b = __read(useDimensions(), 2),
    bodyRef = _b[0],
    bodyDimensions = _b[1];
  var _c = __read(useDimensions(), 2),
    sidebarRef = _c[0],
    sidebarDimensions = _c[1];
  var overallHeight = Math.max(bodyDimensions.height, sidebarDimensions.height);
  var sidebar = useSiteSidebar();
  var showSidebar = sidebar.isAvailable();
  return React.createElement(My.Container, {
    _height: overallHeight,
    hasSidebar: sidebar.isAvailable(),
    sidebarWidth: sidebar.width,
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.Body, {
    ref: bodyRef,
    sidebarWidth: showSidebar ? sidebar.widthMenu : 0
  }, React.createElement(SliceLayoutBoundary, null, React.createElement(My.Header, {
    variant: variant,
    heightMobile: headerHeightMobile,
    heightTablet: headerHeightTablet,
    heightDesktop: headerHeightDesktop
  }, React.createElement(My.Logo, {
    sizeVariant: variant,
    isInverted: isInverted
  }), React.createElement(My.CloseButton, {
    showSidebar: showSidebar,
    variant: variant,
    onClick: onCloseClick,
    color: isInverted ? 'light' : 'strong'
  }, React.createElement(CrossIcon, null))), isLinearNav && hasNavigationMenu && React.createElement(My.LinearNavigation, {
    variant: 'default'
  })), children), showSidebar && React.createElement(My.Sidebar, {
    ref: sidebarRef,
    onCloseClick: onCloseClick
  }));
});
SiteMenuReveal.cls = cls;
SiteMenuReveal.defaultProps = SiteMenuRevealDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;